import React, { useCallback } from 'react'
import { Select } from 'antd'
import { segmentApi } from '@edulastic/api'
import { BULK_CONVERTER_SEGMENT } from '../../../constants/bulkConverterSegment'
import {
  PdlBulkToolbarTopRow,
  PdlBulkToolbarHeadingWrap,
  PdlBulkToolbarSortWrap,
  PdlBulkToolbarFiltersRow,
  PdlBulkFilterSelect,
} from '../Container/styled'

/** Sentinel values for “clear filter” rows in the dropdown (not used as real grade/subject ids). */
const ALL_GRADE_OPTION_VALUE = '__pdl_bulk_all_grade__'
const ALL_SUBJECT_OPTION_VALUE = '__pdl_bulk_all_subject__'

/**
 * After PDL bulk upload: grade/subject filters and sort (`sortSlot`).
 * Upload summary and CSV download live in `BulkConvertStatusBar`.
 */
const PdlBulkPostUploadToolbar = ({
  grades = [],
  subject = [],
  gradeOptions = [],
  subjectOptions = [],
  onGradesChange,
  onSubjectChange,
  sortSlot,
}) => {
  const gradeSingle = Array.isArray(grades) ? grades[0] : grades
  const subjectSingle = Array.isArray(subject) ? subject[0] : subject

  const trackFilter = useCallback(
    (filterName, selectedValue, nextGrade, nextSubject) => {
      segmentApi.genericEventTrack(
        BULK_CONVERTER_SEGMENT.MY_CONTENT_FILTER_SELECTED,
        {
          filterName,
          selectedValue,
          searchParams: {
            gradeLevels: nextGrade != null ? [nextGrade] : [],
            subjects: nextSubject != null ? [nextSubject] : [],
          },
        }
      )
    },
    []
  )

  const handleGrades = (value) => {
    const v =
      value === ALL_GRADE_OPTION_VALUE || value === undefined ? null : value
    trackFilter('grade', v, v, subjectSingle)
    onGradesChange(v != null && v !== '' ? [v] : [])
  }

  const handleSubject = (value) => {
    const v =
      value === ALL_SUBJECT_OPTION_VALUE || value === undefined ? null : value
    trackFilter('subject', v, gradeSingle, v)
    onSubjectChange(v != null && v !== '' ? [v] : [])
  }

  return (
    <PdlBulkToolbarTopRow data-cy="pdlBulkPostUploadToolbar">
      <PdlBulkToolbarHeadingWrap>
        <PdlBulkToolbarFiltersRow data-cy="pdlBulkPostUploadFilters">
          <PdlBulkFilterSelect
            showSearch
            allowClear
            placeholder="All Grade"
            value={
              gradeSingle !== undefined && gradeSingle !== ''
                ? gradeSingle
                : undefined
            }
            onChange={handleGrades}
            dropdownMatchSelectWidth={false}
          >
            <Select.Option
              key={ALL_GRADE_OPTION_VALUE}
              value={ALL_GRADE_OPTION_VALUE}
            >
              All Grade
            </Select.Option>
            {gradeOptions.map(({ value, text }) => (
              <Select.Option key={value} value={value}>
                {text}
              </Select.Option>
            ))}
          </PdlBulkFilterSelect>
          <PdlBulkFilterSelect
            showSearch
            allowClear
            placeholder="All Subject"
            value={
              subjectSingle !== undefined && subjectSingle !== ''
                ? subjectSingle
                : undefined
            }
            onChange={handleSubject}
            dropdownMatchSelectWidth={false}
          >
            <Select.Option
              key={ALL_SUBJECT_OPTION_VALUE}
              value={ALL_SUBJECT_OPTION_VALUE}
            >
              All Subject
            </Select.Option>
            {subjectOptions.map(({ value, text }) => (
              <Select.Option key={value} value={value}>
                {text}
              </Select.Option>
            ))}
          </PdlBulkFilterSelect>
        </PdlBulkToolbarFiltersRow>
      </PdlBulkToolbarHeadingWrap>
      <PdlBulkToolbarSortWrap>{sortSlot}</PdlBulkToolbarSortWrap>
    </PdlBulkToolbarTopRow>
  )
}

export default PdlBulkPostUploadToolbar
